import { api } from './api';

export const fetchClinicSettings = async () => {
    const res = await api.get('/cheart/clinic/settings');
    return res;
};

export const updateClinicSettings = ({ parameters, reason }) =>
    api.post('/cheart/clinic/settings/edit', {
        parameters,
        reason
    });
